import { Close } from '@mui/icons-material';
import { Box, DialogTitle, Divider, IconButton } from '@mui/material';
import { DialogTitleProps } from '@mui/material/DialogTitle/DialogTitle';
import { ReactNode } from 'react';

import { useSXStyles } from '~/components/SolaForceDialogTitle/useStyles';
import { theme } from '~/theme';

type PropsType = DialogTitleProps & {
  onClose?: () => void;
  actions?: ReactNode;
  icon?: ReactNode;
};

export const SolaForceDialogTitle = (props: PropsType) => {
  const { icon, actions, onClose, sx, children, ...restProps } = props;
  const sxStyles = useSXStyles();

  const dialogSxStyle = {
    ...sxStyles.dialog,
    ...sx,
  };

  return (
    <DialogTitle sx={dialogSxStyle} {...restProps}>
      {!!icon && <Box sx={sxStyles.icon}>{icon}</Box>}

      <Box sx={sxStyles.title}>{children}</Box>

      {!!actions && (
        <Box sx={sxStyles.actions}>
          {actions}
          {!!onClose && (
            <Divider orientation={'vertical'} sx={sxStyles.actionsDivider} />
          )}
        </Box>
      )}

      {!!onClose && (
        <Box sx={sxStyles.close}>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              color: theme.palette.grey[500],
            }}
          >
            <Close />
          </IconButton>
        </Box>
      )}
    </DialogTitle>
  );
};
